import { render } from "./index.vue?vue&type=template&id=17298bea"
import script from "./players.ts?vue&type=script&lang=js"
export * from "./players.ts?vue&type=script&lang=js"

import "./players.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script